(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('angular')) :
	typeof define === 'function' && define.amd ? define(['exports', 'angular'], factory) :
	(global = global || self, factory(global['gaf-ng-components-personalization'] = {}, global.angular$1));
}(this, function (exports, angular$1) { 'use strict';

	angular$1 = angular$1 && angular$1.hasOwnProperty('default') ? angular$1['default'] : angular$1;

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	(function () {
	    angular
	        .module('MW.Framework.PersonalizationService', [
	        'MW.Configuration',
	        'MW.Framework.FeatureToggleService'
	    ])
	        .service('PersonalizationService', ['$q',
	        '$http',
	        'PERSONALIZATION_SERVICE_URL',
	        'FeatureToggleService',
	        '$log',
	        function ($q, $http, PERSONALIZATION_SERVICE_URL, FeatureToggleService, $log) {
	            var personalizationCaches = {}, currentCompanyId;
	            function PersonalizationCache(userId, companyId) {
	                this.userId = userId;
	                this.companyId = companyId;
	                this.hiddenIdsObject = {};
	            }
	            /**
	             * Gets the visibility settings for a user-company cross section
	             *
	             * @param {String|Array} feature The feature being requested (e.g searches) or a list of features
	             */
	            function getHiddenIdsObject(userId, companyId, feature, hiddenIdsObject) {
	                if (typeof feature === 'string') {
	                    feature = [feature];
	                }
	                var queryParams = '';
	                for (var i = 0; i < feature.length; i++) {
	                    if (i === 0) {
	                        queryParams += '?features=' + feature[i];
	                    }
	                    else {
	                        queryParams += '&features=' + feature[i];
	                    }
	                }
	                return FeatureToggleService.isOn('personalizationToggle').then(function (isEnabled) {
	                    if (!isEnabled) {
	                        for (var i = 0; i < feature.length; i++) {
	                            hiddenIdsObject[feature[i]] = {};
	                        }
	                        return hiddenIdsObject;
	                    }
	                    else {
	                        var shouldMakeCall = false;
	                        for (var i = 0; i < feature.length; i++) {
	                            if (!hiddenIdsObject.hasOwnProperty(feature[i])) {
	                                shouldMakeCall = true;
	                                break;
	                            }
	                        }
	                        if (shouldMakeCall) {
	                            return $http.get(PERSONALIZATION_SERVICE_URL + '/user/' + userId + '/company/' + companyId + '/' + queryParams)
	                                .then(function (response) {
	                                // update the cache
	                                var personalizations = response.data;
	                                for (var key in personalizations) {
	                                    hiddenIdsObject[key] = personalizations[key];
	                                }
	                                return hiddenIdsObject;
	                            });
	                        }
	                        else {
	                            return $q.when(hiddenIdsObject);
	                        }
	                    }
	                });
	            }
	            /**
	             * Clears the internal cache of personalization settings
	             */
	            function clearCaches() {
	                personalizationCaches = {};
	                currentCompanyId = null;
	            }
	            function getPersonalizationCache(userId, companyId) {
	                if (!currentCompanyId) {
	                    currentCompanyId = companyId;
	                }
	                else if (companyId != currentCompanyId) {
	                    clearCaches();
	                    currentCompanyId = companyId;
	                }
	                if (!personalizationCaches.hasOwnProperty(userId)) {
	                    personalizationCaches[userId] = new PersonalizationCache(userId, companyId);
	                }
	                return personalizationCaches[userId];
	            }
	            /**
	             * Adds an 'isHidden' field to each item in the collection indicating whether the 'hidden' personalization
	             * feature is true or false for that item.
	             *
	             * @param {String} userId ID of the user to add the annotations for
	             * @param {String} companyId ID of the company to add the annotations for
	             * @param {Array} collection List of items to annotate
	             * @param {String} type Type of the items in the collection (e.g. 'searches', 'dashboards', 'tags'
	             * @param {String} uniqueIdField The unique ID field in the collection that's used by personalization (e.g. 'savedSearchId')
	             */
	            function annotateCollectionWithIsHidden(userId, companyId, collection, type, uniqueIdField) {
	                var personalizationCache = getPersonalizationCache(userId, companyId);
	                return personalizationCache.annotateCollectionWithIsHidden(collection, type, uniqueIdField);
	            }
	            PersonalizationCache.prototype.annotateCollectionWithIsHidden = function _annotateCollectionWithIsHidden(collection, type, uniqueIdField) {
	                return getHiddenIdsObject(this.userId, this.companyId, type, this.hiddenIdsObject).then(function annotateCollection(_hiddenIdsObject) {
	                    angular.forEach(collection, function annotateItem(item) {
	                        var isHidden = _hiddenIdsObject.hasOwnProperty(type) &&
	                            _hiddenIdsObject[type].hasOwnProperty(item[uniqueIdField]) &&
	                            _hiddenIdsObject[type][item[uniqueIdField]].hidden;
	                        item.isHidden = isHidden;
	                    });
	                    return collection;
	                });
	            };
	            /**
	             * Loads data for the given user, company and type.  Used to load data for subsequent calls to the *Sync methods
	             *
	             * @param {String} userId ID of the user to add the annotations for
	             * @param {String} companyId ID of the company to add the annotations for
	             * @param {String|Array} type Type(s) of the items in the collection (e.g. 'searches', 'dashboards', 'tags')
	             * @returns {Promise}
	             */
	            function loadPersonalizationData(userId, companyId, type) {
	                var personalizationCache = getPersonalizationCache(userId, companyId);
	                return personalizationCache.loadPersonalizationData(typeof (type) == 'string' ? [type] : type);
	            }
	            PersonalizationCache.prototype.loadPersonalizationData = function _loadPersonalizationData(types) {
	                return getHiddenIdsObject(this.userId, this.companyId, types, this.hiddenIdsObject);
	            };
	            /**
	             * Identical to annotateCollectionWithIsHidden but does its work synchronously.  It assumes that loadPeronalizationData
	             * has already been called.  It is recommended that the asynchronous version (the other one) be used whenever possible.
	             *
	             * @param userId
	             * @param companyId
	             * @param collection - List of items to annotate
	             * @param types {String|Array|Object} - Either a string or array of strings identifying the types (e.g. searches,
	             *      rssFeeds, tags) to compare against or an object with a mapping of types to ids.  If an object is provided
	             *      the uniqueIdField argument does not apply.
	             * @param uniqueIdField {String|undefined} - Field to use in comparisons.  If the types argument is an object,
	             *      this argument should not be provided.
	             * @returns {*}
	             */
	            function annotateCollectionWithIsHiddenSync(userId, companyId, collection, types, uniqueIdField) {
	                var fieldTypeMapping = {}, personalizationCache;
	                if (typeof types === 'string') {
	                    fieldTypeMapping[types] = uniqueIdField;
	                }
	                else if (Array.isArray(types)) {
	                    types.forEach(function (type) {
	                        fieldTypeMapping[type] = uniqueIdField;
	                    });
	                }
	                else {
	                    fieldTypeMapping = types;
	                }
	                if (!personalizationCaches.hasOwnProperty(userId) || companyId != currentCompanyId) {
	                    $log.error('PersonalizationService has not been initialized with the correct user and company');
	                    return collection;
	                }
	                personalizationCache = getPersonalizationCache(userId, companyId);
	                return personalizationCache.annotateCollectionWithIsHiddenSync(collection, fieldTypeMapping);
	            }
	            PersonalizationCache.prototype.annotateCollectionWithIsHiddenSync = function _annotateCollectionWithIsHiddenSync(collection, fieldTypeMapping) {
	                var _this = this;
	                for (var type in fieldTypeMapping) {
	                    if (!_this.hiddenIdsObject.hasOwnProperty(type)) {
	                        $log.error('PersonalizationService has not been initialized!');
	                        return collection;
	                    }
	                }
	                angular.forEach(collection, function annotateItem(item) {
	                    for (var type in fieldTypeMapping) {
	                        var isHidden = _this.hiddenIdsObject[type].hasOwnProperty(item[fieldTypeMapping[type]]) &&
	                            _this.hiddenIdsObject[type][item[fieldTypeMapping[type]]].hidden;
	                        item.isHidden = isHidden;
	                        // bail as soon as we decide it's hidden.  we don't want to unhide if we're looping over
	                        // multiple types
	                        if (isHidden) {
	                            break;
	                        }
	                    }
	                });
	                return collection;
	            };
	            /**
	             * Filters items out of collection that are hidden.  Assumes loadPersonalizationData has already been called.
	             * A shallow copy of the collection is returned.
	             *
	             * @param userId
	             * @param companyId
	             * @param collection
	             * @param type
	             * @param uniqueIdField
	             */
	            function filterHiddenItemsSync(userId, companyId, collection, type, uniqueIdField) {
	                var personalizationCache;
	                if (!personalizationCaches.hasOwnProperty(userId) || companyId != currentCompanyId) {
	                    $log.error('PersonalizationService has not been initialized with the correct user and company');
	                    return collection;
	                }
	                personalizationCache = getPersonalizationCache(userId, companyId);
	                return personalizationCache.filterHiddenItemsSync(collection, type, uniqueIdField);
	            }
	            PersonalizationCache.prototype.filterHiddenItemsSync = function _filterHiddenItemsSync(collection, type, uniqueIdField) {
	                var visibleItems = [], _this = this;
	                if (!_this.hiddenIdsObject.hasOwnProperty(type)) {
	                    $log.error('PersonalizationService has not been initialized!');
	                    return collection;
	                }
	                angular.forEach(collection, function annotateItem(item) {
	                    var isHidden = _this.hiddenIdsObject[type].hasOwnProperty(item[uniqueIdField]) &&
	                        _this.hiddenIdsObject[type][item[uniqueIdField]].hidden;
	                    if (!isHidden) {
	                        visibleItems.push(item);
	                    }
	                });
	                return visibleItems;
	            };
	            function updateCollectionVisibility(userId, companyId, personalizations) {
	                if (companyId !== currentCompanyId) {
	                    $log.error('Company id does not match the current company id during personalization update', { currentCompanyId: currentCompanyId, companyId: companyId });
	                    return $q.reject(new Error('Personalization update failed'));
	                }
	                var personalizationCache = getPersonalizationCache(userId, companyId);
	                return personalizationCache.updateCollectionVisibility(personalizations);
	            }
	            PersonalizationCache.prototype.updateCollectionVisibility = function _updateCollectionVisibility(personalizations) {
	                var _this = this;
	                return $http.put(PERSONALIZATION_SERVICE_URL + '/user/' + this.userId + '/company/' + this.companyId + '/', personalizations)
	                    .then(function (response) {
	                    var updatedPersonalizations = response.data;
	                    // we get the fully updated list of personalizations here so we can just overwrite the cache
	                    for (var key in updatedPersonalizations) {
	                        _this.hiddenIdsObject[key] = updatedPersonalizations[key];
	                    }
	                    return _this.hiddenIdsObject;
	                });
	            };
	            function bulkUpdateCollectionVisibility(userIds, companyId, personalizations) {
	                if (companyId !== currentCompanyId) {
	                    $log.error('Company id does not match the current company id during personalization update', { currentCompanyId: currentCompanyId, companyId: companyId });
	                    return $q.reject(new Error('Personalization update failed'));
	                }
	                var chunk = 100, updatePromises = [];
	                for (var i = 0; i < userIds.length; i += chunk) {
	                    var tempArray = userIds.slice(i, i + chunk);
	                    updatePromises.push(bulkUpdateBatch(tempArray, companyId, personalizations));
	                }
	                return $q.all(updatePromises);
	            }
	            function bulkUpdateBatch(userIds, companyId, personalizations) {
	                var personalizationCache, payload = { userIds: userIds, features: personalizations };
	                // update the caches first in case the user opens up the dialog again before the save completes.  if something
	                // goes wrong, we'll clear the caches
	                for (var i in userIds) {
	                    personalizationCache = getPersonalizationCache(userIds[i], companyId);
	                    personalizationCache.merge(personalizations);
	                }
	                return $http.put(PERSONALIZATION_SERVICE_URL + '/company/' + companyId + '/', payload)
	                    .catch(function (error) {
	                    // if something went wrong, we don't know what state we're in.  clear all the caches and just let
	                    // them get reloaded
	                    clearCaches();
	                    return $q.reject(error);
	                });
	            }
	            PersonalizationCache.prototype.merge = function merge(personalizations) {
	                for (var feature in personalizations) {
	                    // don't merge into any personalization features that we don't already have data for.  that's guaranteed to
	                    // make us lose data
	                    if (!this.hiddenIdsObject.hasOwnProperty(feature)) {
	                        continue;
	                    }
	                    for (var id in personalizations[feature]) {
	                        for (var personalization in personalizations[feature][id]) {
	                            if (!this.hiddenIdsObject[feature].hasOwnProperty(id)) {
	                                this.hiddenIdsObject[feature][id] = {};
	                            }
	                            this.hiddenIdsObject[feature][id][personalization] = personalizations[feature][id][personalization];
	                        }
	                    }
	                }
	                return this.hiddenIdsObject;
	            };
	            /**
	             * Hides a list of collection items for a user-company
	             *
	             * @param {String} userId The id of the user to filter for
	             * @param {String} companyId The id of the company to filter for
	             * @param {String} type The type of the collection to hide items in (e.g. 'searches', 'dashboards', 'tags')
	             * @param {Array} itemIds An array of item ids to hide
	             */
	            function hideCollectionItems(userId, companyId, type, itemIds) {
	                if (companyId !== currentCompanyId) {
	                    $log.error('Company id does not match the current company id during personalization update', { currentCompanyId: currentCompanyId, companyId: companyId });
	                    return $q.reject(new Error('Personalization update failed'));
	                }
	                var personalizationCache = getPersonalizationCache(userId, companyId);
	                return personalizationCache.hideCollectionItems(type, itemIds);
	            }
	            PersonalizationCache.prototype.hideCollectionItems = function _hideCollectionItems(type, itemIds) {
	                var personalizations = {}, hideObj = {};
	                for (var i = 0; i < itemIds.length; i++) {
	                    hideObj[itemIds[i]] = {};
	                    hideObj[itemIds[i]].hidden = true;
	                }
	                personalizations[type] = hideObj;
	                return this.updateCollectionVisibility(personalizations);
	            };
	            /**
	             * Shows a list of collection items for a user-company
	             *
	             * @param {String} userId The id of the user to filter for
	             * @param {String} companyId The id of the company to filter for
	             * @param {String} type The type of the collection to show items in (e.g. 'searches', 'dashboards', 'tags')
	             * @param {Array} itemIds An array of item ids to show
	             */
	            function showCollectionItems(userId, companyId, type, itemIds) {
	                if (companyId !== currentCompanyId) {
	                    $log.error('Company id does not match the current company id during personalization update', { currentCompanyId: currentCompanyId, companyId: companyId });
	                    return $q.reject(new Error('Personalization update failed'));
	                }
	                var personalizationCache = getPersonalizationCache(userId, companyId);
	                return personalizationCache.showCollectionItems(type, itemIds);
	            }
	            PersonalizationCache.prototype.showCollectionItems = function _showCollectionItems(type, itemIds) {
	                var personalizations = {}, showObj = {};
	                for (var i = 0; i < itemIds.length; i++) {
	                    showObj[itemIds[i]] = {};
	                    showObj[itemIds[i]].hidden = false;
	                }
	                personalizations[type] = showObj;
	                return this.updateCollectionVisibility(personalizations);
	            };
	            /**
	             * Resets visibility setting for rss entry
	             */
	            function resetRSSVisibility(rssId) {
	                for (var i in personalizationCaches) {
	                    personalizationCaches[i].resetRSSVisibility(rssId);
	                }
	            }
	            PersonalizationCache.prototype.resetRSSVisibility = function _resetRSSVisibility(rssId) {
	                this.hiddenIdsObject.rssFeeds[rssId] = { 'hidden': false };
	            };
	            return {
	                hideCollectionItems: hideCollectionItems,
	                showCollectionItems: showCollectionItems,
	                updateCollectionVisibility: updateCollectionVisibility,
	                bulkUpdateCollectionVisibility: bulkUpdateCollectionVisibility,
	                resetRSSVisibility: resetRSSVisibility,
	                annotateCollectionWithIsHidden: annotateCollectionWithIsHidden,
	                loadPersonalizationData: loadPersonalizationData,
	                annotateCollectionWithIsHiddenSync: annotateCollectionWithIsHiddenSync,
	                filterHiddenItemsSync: filterHiddenItemsSync,
	                clearCaches: clearCaches
	            };
	        }]);
	}());

	(function () {
	    angular
	        .module('MW.Framework.VisibilityPersonalizationDialog', [
	        'ngMaterial',
	        'ngMessages',
	        'pascalprecht.translate'
	    ])
	        .component('visibilityPersonalizationDialog', {
	        bindings: {
	            users: '<',
	            personalizationStatesDeferred: '<',
	            labelsFeatureEnabled: '<'
	        },
	        template: '<mw-mini-modal-dialog no-padding="true" class="mw-mini-modal-dialog" layout="column" dialog-title="{{$ctrl.modalTitle | translate}}" ok="{{ \'mw-user-collection__action-visibility-personalization-dialog-save\' | translate }}" cancel="{{ \'mw-user-collection__action-visibility-personalization-dialog-cancel\' | translate }}" on-ok="$ctrl.handleOk($event)" on-cancel="$ctrl.handleCancel($event)">' +
	            '<mw-modal-find ng-if="$ctrl.allDataLoaded">' +
	            '<div class="mw-menu__input-wrapper">' +
	            '<md-input-container class="mw-menu__input-container mw-menu__input-container--border-bottom" md-no-float="md-no-float">' +
	            '<md-icon md-svg-icon="action:ic_search_24px" aria-label="" class="mw-menu__input-find-icon"></md-icon>' +
	            '<input md-autofocus class="mw-menu__input-field" type="text" translate translate-attr-placeholder="mw-user-collection__action-visibility-personalization-dialog-find" translate-default="mw-user-collection__action-visibility-personalization-dialog-find" aria-label="{{"mw-user-collection__action-visibility-personalization-dialog-find" | translate}" ng-model="$ctrl.searchText"/>' +
	            '<md-icon md-svg-icon="navigation:ic_cancel_24px" ng-show="$ctrl.searchText.length > 0" ng-click="$ctrl.searchText = \'\'" md-prevent-menu-close="true" aria-label="{{\'mw-user-collection__action-visibility-personalization-dialog-clear\'}}" class="mw-menu__input-find-cancel"> </md-icon>' +
	            '</md-input-container>' +
	            '</div>' +
	            '</mw-modal-find>' +
	            '<mw-modal-content>' +
	            '<mw-loader ng-if="!$ctrl.allDataLoaded"></mw-loader>' +
	            '<ng-form ng-if="$ctrl.allDataLoaded">' +
	            '<div layout="column">' +
	            '<div layout="row">' +
	            '<div flex>' +
	            '<mw-menu-subheader action-label="{{$ctrl.getBulkActionText(\'dashboards\')}}" on-action-click="$ctrl.toggleSectionSelection(\'dashboards\')"><span translate="mw-user-collection__action-visibility-personalization-dialog-dashboards"/></mw-menu-subheader>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog--dashboard-lookup-failed mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.dashboards === undefined">' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--dashboards-fail"></div>' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--try-again"></div>' +
	            '</div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.dashboards !== undefined && $ctrl.personalizationStates.dashboards.length == 0" translate="mw-user-collection__action-visibility-personalization-dialog-empty-dashboards"></div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.dashboards !== undefined && $ctrl.personalizationStates.dashboards.length != 0 && filteredDashboards.length == 0">{{ "mw-user-collection__action-visibility-personalization-dialog-empty-dashboards--filtered" | translate:$ctrl }}</div>' +
	            '<mw-menu-item ng-repeat="dashboard in filteredDashboards = ($ctrl.personalizationStates.dashboards | filter: {\'name\' : $ctrl.searchText}) | orderBy: \'name\'" type="multiselect" aria-label="dashboard.name" on-click="$ctrl.toggleVisibility(dashboard, \'dashboards\')" is-indeterminate="dashboard.visibility == \'conflict\'" is-selected="dashboard.visibility == \'visible\'">' +
	            '{{::dashboard.name}}' +
	            '<mw-menu-item-icons>' +
	            '<md-icon md-svg-icon="{{::$ctrl.getDashboardTypeIcon(dashboard)}}" />' +
	            '</mw-menu-item-icons>' +
	            '</mw-menu-item>' +
	            '</div>' +
	            '</div>' +
	            '<div layout="row">' +
	            '<div flex>' +
	            '<mw-menu-subheader action-label="{{$ctrl.getBulkActionText(\'searches\')}}" on-action-click="$ctrl.toggleSectionSelection(\'searches\')"><span translate="mw-user-collection__action-visibility-personalization-dialog-searches"/></mw-menu-subheader>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog--search-lookup-failed mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.searches === undefined">' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--searches-fail"></div>' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--try-again"></div>' +
	            '</div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.searches !== undefined && $ctrl.personalizationStates.searches.length == 0" translate="mw-user-collection__action-visibility-personalization-dialog-empty-searches"></div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.searches !== undefined && $ctrl.personalizationStates.searches.length != 0 && filteredSearches.length == 0">{{ "mw-user-collection__action-visibility-personalization-dialog-empty-searches--filtered" | translate:$ctrl }}</div>' +
	            '<mw-menu-item ng-repeat="search in filteredSearches = ($ctrl.personalizationStates.searches | filter: $ctrl.filterSearches) | orderBy: \'name\'" type="multiselect" aria-label="search.name" on-click="$ctrl.toggleVisibility(search, \'searches\')" is-indeterminate="search.visibility == \'conflict\'" is-selected="search.visibility == \'visible\'">' +
	            '{{::search.name}}' +
	            '<mw-menu-item-icons>' +
	            '<md-icon ng-if="::search.type === \'news\'" md-svg-icon="meltwater:editorial"></md-icon>' +
	            '<md-icon ng-if="::search.type === \'social\'" md-svg-icon="meltwater:social"></md-icon>' +
	            '<md-icon ng-if="::search.type === \'broadcast\'" md-svg-icon="meltwater:broadcast"></md-icon>' +
	            '</mw-menu-item-icons>' +
	            '</mw-menu-item>' +
	            '</div>' +
	            '</div>' +
	            '<div layout="row">' +
	            '<div flex>' +
	            '<mw-menu-subheader action-label="{{$ctrl.getBulkActionText(\'tags\')}}" on-action-click="$ctrl.toggleSectionSelection(\'tags\')"><span translate="mw-user-collection__action-visibility-personalization-dialog-tags"/></mw-menu-subheader>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog--tag-lookup-failed mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.tags === undefined">' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--tags-fail"></div>' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--try-again"></div>' +
	            '</div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.tags !== undefined && $ctrl.personalizationStates.tags.length == 0" translate="mw-user-collection__action-visibility-personalization-dialog-empty-tags"></div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.tags !== undefined && $ctrl.personalizationStates.tags.length != 0 && filteredTags.length == 0">{{ "mw-user-collection__action-visibility-personalization-dialog-empty-tags--filtered" | translate:$ctrl }}</div>' +
	            '<mw-menu-item ng-repeat="tag in filteredTags = ($ctrl.personalizationStates.tags | filter: {\'name\' : $ctrl.searchText}) | orderBy: \'name\'" type="multiselect" aria-label="tag.name" on-click="$ctrl.toggleVisibility(tag, \'tags\')" is-indeterminate="tag.visibility == \'conflict\'" is-selected="tag.visibility == \'visible\'">' +
	            '{{::tag.name}}' +
	            '<mw-menu-item-icons>' +
	            '<md-icon md-svg-icon="meltwater:tag" />' +
	            '</mw-menu-item-icons>' +
	            '</mw-menu-item>' +
	            '</div>' +
	            '</div>' +
	            '<div layout="row">' +
	            '<div flex>' +
	            '<mw-menu-subheader action-label="{{$ctrl.getBulkActionText(\'rssFeeds\')}}" on-action-click="$ctrl.toggleSectionSelection(\'rssFeeds\')"><span translate="mw-user-collection__action-visibility-personalization-dialog-rss-feeds"/></mw-menu-subheader>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog--rssFeed-lookup-failed mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.rssFeeds === undefined">' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--rssFeeds-fail"></div>' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--try-again"></div>' +
	            '</div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.rssFeeds !== undefined && $ctrl.personalizationStates.rssFeeds.length == 0" translate="mw-user-collection__action-visibility-personalization-dialog-empty-rssFeeds"></div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.rssFeeds !== undefined && $ctrl.personalizationStates.rssFeeds.length != 0 && filteredRssFeeds.length == 0">{{ "mw-user-collection__action-visibility-personalization-dialog-empty-rssFeeds--filtered" | translate:$ctrl }}</div>' +
	            '<mw-menu-item ng-repeat="rssFeed in filteredRssFeeds = ($ctrl.personalizationStates.rssFeeds | filter: {\'name\' : $ctrl.searchText}) | orderBy: \'name\'" type="multiselect" aria-label="rssFeed.name" on-click="$ctrl.toggleVisibility(rssFeed, \'rssFeeds\')" is-indeterminate="rssFeed.visibility == \'conflict\'" is-selected="rssFeed.visibility == \'visible\'">' +
	            '{{::rssFeed.name}}' +
	            '<mw-menu-item-icons>' +
	            '<md-icon md-svg-icon="meltwater:rss" />' +
	            '</mw-menu-item-icons>' +
	            '</mw-menu-item>' +
	            '</div>' +
	            '</div>' +
	            '<div layout="row" ng-if="$ctrl.labelsFeatureEnabled">' +
	            '<div flex>' +
	            '<mw-menu-subheader action-label="{{$ctrl.getBulkActionText(\'labels\')}}" on-action-click="$ctrl.toggleSectionSelection(\'labels\')"><span translate="mw-user-collection__action-visibility-personalization-dialog-labels"/></mw-menu-subheader>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog--labels-lookup-failed mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.labels === undefined">' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--labels-fail"></div>' +
	            '<div translate="mw-user-collection__action-visibility-personalization-dialog--try-again"></div>' +
	            '</div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.labels !== undefined && $ctrl.personalizationStates.labels.length == 0" translate="mw-user-collection__action-visibility-personalization-dialog-empty-labels"></div>' +
	            '<div class="mw-user-collection__action-visibility-personalization-dialog-message--sub-text" ng-if="$ctrl.personalizationStates.labels !== undefined && $ctrl.personalizationStates.labels.length != 0 && filteredLabels.length == 0">{{ "mw-user-collection__action-visibility-personalization-dialog-empty-labels--filtered" | translate:$ctrl }}</div>' +
	            '<mw-menu-item ng-repeat="label in filteredLabels = ($ctrl.personalizationStates.labels | filter: {\'name\' : $ctrl.searchText}) | orderBy: \'name\'" type="multiselect" aria-label="label.name" on-click="$ctrl.toggleVisibility(label, \'labels\')" is-indeterminate="label.visibility == \'conflict\'" is-selected="label.visibility == \'visible\'">' +
	            '{{::label.name}}' +
	            '<mw-menu-item-icons>' +
	            '<md-icon>' +
	            // Icon copied from: https://assets.meltwater.io/flux-icons/latest/actions/svg/label.svg
	            '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20"><path d="M17.8,9.4L14,4.8c-0.2-0.2-0.4-0.3-0.6-0.3H2.8C2.4,4.6,2,4.9,2,5.4v9.3c0,0.4,0.4,0.8,0.8,0.8h10.6c0.2,0,0.5-0.1,0.6-0.3 l3.8-4.7C18.1,10.1,18.1,9.7,17.8,9.4z M3.6,6.2h2v7.7h-2V6.2z M13,13.8H7.2V6.2H13l3.1,3.8L13,13.8z"/></svg>' +
	            '</md-icon>' +
	            '</mw-menu-item-icons>' +
	            '</mw-menu-item>' +
	            '</div>' +
	            '</div>' +
	            '</div>' +
	            '</ng-form>' +
	            '</mw-modal-content>' +
	            '</mw-mini-modal-dialog>',
	        controller: [
	            '$mdDialog',
	            '$q',
	            '$log',
	            'DialogService',
	            '$translate',
	            VisibilityPersonalizationDialogController
	        ]
	    });
	    function VisibilityPersonalizationDialogController($mdDialog, $q, $log, DialogService, $translate) {
	        var originalPersonalizationStates = {}, ctrl;
	        ctrl = this;
	        this.areAllSelected = {
	            dashboards: false,
	            rssFeeds: false,
	            tags: false,
	            searches: false
	        };
	        $translate('mw-user-collection__action-visibility-personalization-dialog-submenu-clear').then(function (translation) {
	            ctrl.clearText = translation;
	        });
	        $translate('mw-user-collection__action-visibility-personalization-dialog-submenu-select-all').then(function (translation) {
	            ctrl.selectAllText = translation;
	        });
	        this.modalTitle = 'mw-user-collection__edit-user-dialog__modalTitle-edit-visibility';
	        this.searchText = '';
	        this.$onInit = function onInit() {
	            ctrl.personalizationStatesDeferred.promise
	                .then(function initializeDialog(_personalizationStates) {
	                ctrl.personalizationStates = _personalizationStates;
	                originalPersonalizationStates = angular.copy(_personalizationStates);
	                setSectionSelectionStatus();
	                ctrl.allDataLoaded = true;
	            })
	                .catch(function handleInitializeError(error) {
	                ctrl.allDataLoaded = true; // just let it show the failure messages
	                $log.error('Failed initializing personalization dialog', error);
	            });
	        };
	        this.handleCancel = function () {
	            $mdDialog.cancel();
	        };
	        this.handleOk = function () {
	            $mdDialog.hide({
	                users: this.users,
	                personalizationStates: calculatePersonalizationDifferences()
	            });
	        };
	        this.toggleVisibility = function toggleVisibility(item, objectType) {
	            if (item.visibility == 'hidden' || item.visibility == 'conflict') {
	                item.visibility = 'visible';
	                setSectionSelectionStatus(objectType);
	            }
	            else if (item.visibility == 'visible') {
	                item.visibility = 'hidden';
	                ctrl.areAllSelected[objectType] = false;
	            }
	            else {
	                $log.error('Unknown visibility state "' + item.visibility + '"');
	            }
	        };
	        this.getDashboardTypeIcon = function (dashboard) {
	            var templateId = dashboard && dashboard.templateId ? dashboard.templateId : '';
	            if (templateId.indexOf('benchmark') === 0) {
	                return 'meltwater:analyse';
	            }
	            if (templateId.indexOf('analyze') === 0) {
	                return 'meltwater:brain';
	            }
	            if (templateId.indexOf('monitor') === 0) {
	                return 'meltwater:monitor';
	            }
	            return 'meltwater:cog';
	        };
	        this.toggleSectionSelection = function (section) {
	            if (ctrl.areAllSelected[section]) {
	                clearAll(section);
	            }
	            else {
	                selectAll(section);
	            }
	        };
	        this.filterSearches = function (item) {
	            if (ctrl.searchText.length !== 0) {
	                return item.type.indexOf(ctrl.searchText) !== -1 || item.name.indexOf(ctrl.searchText) !== -1;
	            }
	            else {
	                return true;
	            }
	        };
	        this.getBulkActionText = function (section) {
	            if (ctrl.searchText.length !== 0 || !ctrl.personalizationStates[section] || ctrl.personalizationStates[section] === undefined || ctrl.personalizationStates[section].length === 0) {
	                return '';
	            }
	            else {
	                if (ctrl.areAllSelected[section]) {
	                    return ctrl.clearText;
	                }
	                else {
	                    return ctrl.selectAllText;
	                }
	            }
	        };
	        function selectAll(section) {
	            for (var i = 0; i < ctrl.personalizationStates[section].length; i++) {
	                ctrl.personalizationStates[section][i].visibility = 'visible';
	                setSectionSelectionStatus(section);
	            }
	        }
	        function clearAll(section) {
	            for (var i = 0; i < ctrl.personalizationStates[section].length; i++) {
	                ctrl.personalizationStates[section][i].visibility = 'hidden';
	                setSectionSelectionStatus(section);
	            }
	        }
	        function calculatePersonalizationDifferences() {
	            var differences = {};
	            for (var type in originalPersonalizationStates) {
	                for (var i in originalPersonalizationStates[type]) {
	                    var id = originalPersonalizationStates[type][i].id;
	                    if (originalPersonalizationStates[type][i].visibility != ctrl.personalizationStates[type][i].visibility) {
	                        if (differences[type] === undefined) {
	                            differences[type] = {};
	                        }
	                        differences[type][id] = { visibility: ctrl.personalizationStates[type][i].visibility };
	                    }
	                }
	            }
	            return differences;
	        }
	        function setSectionSelectionStatus(section) {
	            if (section) {
	                if (ctrl.personalizationStates[section] !== undefined) {
	                    var areAllSelected = true;
	                    for (var i = 0; i < ctrl.personalizationStates[section].length; i++) {
	                        if (ctrl.personalizationStates[section][i].visibility !== 'visible') {
	                            areAllSelected = false;
	                            break;
	                        }
	                    }
	                    ctrl.areAllSelected[section] = areAllSelected;
	                }
	            }
	            else {
	                for (var field in ctrl.personalizationStates) {
	                    setSectionSelectionStatus(field);
	                }
	            }
	        }
	    }
	})();

	angular.module('MW.Framework.VisibilityPersonalizationDialogService', [
	    'MW.Framework.PersonalizationService',
	    'MW.Framework.VisibilityPersonalizationDialog',
	    'MW.Framework.VisibilityPersonalizationConfig',
	    'MW.Framework.DialogService',
	    'MW.Framework.TranslationService'
	])
	    .service('VisibilityPersonalizationDialogService', ['DASHBOARD_SERVICES_URL',
	    'MASF_SERVICES_URL',
	    'MASF_TAG_SERVICES_URL',
	    'DASHBOARD_SERVICES_SOURCE_CRAWLER_URL',
	    'FEATURE_TOGGLE_URL',
	    'ENV',
	    '$http',
	    'PersonalizationService',
	    '$q',
	    'DialogService',
	    '$log',
	    '$mdDialog',
	    'translationService',
	    'PersonalizationConfig',
	    function VisibilityPersonalizationDialogService(DASHBOARD_SERVICES_URL, MASF_SERVICES_URL, MASF_TAG_SERVICES_URL, DASHBOARD_SERVICES_SOURCE_CRAWLER_URL, FEATURE_TOGGLE_URL, ENV, $http, PersonalizationService, $q, DialogService, $log, $mdDialog, translationService, PersonalizationConfig) {
	        var currentUsers, currentCompanyId;
	        return {
	            openModal: openModal,
	            getPersonalizationStates: getPersonalizationStates
	        };
	        function getDashboards() {
	            return $http.get(DASHBOARD_SERVICES_URL + '/dashboard/list')
	                .then(function transformDashboards(response) {
	                return response.data.map(function (dashboard) {
	                    return { id: dashboard._id, name: dashboard.title, templateId: dashboard.templateId };
	                });
	            })
	                .catch(function handleDashboardRetrievalFailure(error) {
	                $log.error('Failed retrieving dashboards for visibility dialog', error);
	                return undefined;
	            });
	        }
	        function getSearches() {
	            return $http.get(MASF_SERVICES_URL + '/list/' + currentCompanyId)
	                .then(function transformSearches(response) {
	                return response.data.map(function (search) {
	                    return { id: search.savedSearchId, name: search.name, type: search.searchQuery.informationTypes[0] };
	                });
	            })
	                .catch(function handleSearchRetrievalFailure(error) {
	                $log.error('Failed retrieving searches for visibility dialog', error);
	                return undefined;
	            });
	        }
	        function getRssFeeds() {
	            return $http.get(DASHBOARD_SERVICES_SOURCE_CRAWLER_URL + '/list/' + currentCompanyId)
	                .then(function transformRssFeeds(response) {
	                return response.data.map(function (rss) {
	                    return { id: rss.id, name: rss.name };
	                });
	            })
	                .catch(function handleSearchRetrievalFailure(error) {
	                $log.error('Failed retrieving rss feeds for visibility dialog', error);
	                return undefined;
	            });
	        }
	        function getTags() {
	            return $http.get(MASF_TAG_SERVICES_URL + '/')
	                .then(function transformTags(response) {
	                return response.data.map(function (tag) {
	                    return { id: tag.tagId, name: tag.name };
	                });
	            })
	                .catch(function handleTagRetrievalFailure(error) {
	                $log.error('Failed retrieving tags for visibility dialog', error);
	                return undefined;
	            });
	        }
	        function getLabels() {
	            return $http.get(PersonalizationConfig.labelsUri + '/company/' + currentCompanyId)
	                .then(function transformLabels(response) {
	                return response.data.map(function (label) {
	                    return { id: label._id, name: label.name };
	                });
	            })
	                .catch(function labelError(error) {
	                $log.error('Failed fetching labels', error);
	                return undefined;
	            });
	        }
	        function buildAnnotatedPersonalizationState(personalizationStates, user) {
	            var annotatedPersonalizationStates = {}, fieldTypeMapping;
	            for (var feature in personalizationStates) {
	                if (personalizationStates[feature]) {
	                    fieldTypeMapping = {};
	                    fieldTypeMapping[feature] = 'id';
	                    annotatedPersonalizationStates[feature] = PersonalizationService.annotateCollectionWithIsHiddenSync(user._id, currentCompanyId, personalizationStates[feature], fieldTypeMapping);
	                }
	            }
	            return annotatedPersonalizationStates;
	        }
	        function getPersonalizationStates() {
	            var personalizationStates;
	            return $q.all({
	                dashboards: getDashboards(),
	                searches: getSearches(),
	                rssFeeds: getRssFeeds(),
	                tags: getTags(),
	                labels: getLabels()
	            })
	                .then(function mergePersonalizationData(_personalizationStates) {
	                personalizationStates = _personalizationStates;
	                currentUsers.map(function mergePersonalizationDataForUser(user) {
	                    var annotatedPersonalizationStates = buildAnnotatedPersonalizationState(angular.copy(personalizationStates), user);
	                    for (var type in annotatedPersonalizationStates) {
	                        for (var i in personalizationStates[type]) {
	                            if (personalizationStates[type][i].visibility === undefined) {
	                                // no existing state so it can be whatever the current user is
	                                personalizationStates[type][i].visibility = annotatedPersonalizationStates[type][i].isHidden ? 'hidden' : 'visible';
	                            }
	                            else {
	                                // we already have a state from another user so check for conflicts
	                                if (personalizationStates[type][i].visibility == 'hidden' && !annotatedPersonalizationStates[type][i].isHidden) {
	                                    personalizationStates[type][i].visibility = 'conflict';
	                                }
	                                else if (personalizationStates[type][i].visibility == 'visible' && annotatedPersonalizationStates[type][i].isHidden) {
	                                    personalizationStates[type][i].visibility = 'conflict';
	                                }
	                            }
	                        }
	                    }
	                });
	                return personalizationStates;
	            });
	        }
	        function getPersonalizationStatesDeferred() {
	            var deferred = $q.defer();
	            getPersonalizationStates()
	                .then(function (personalizationStates) {
	                deferred.resolve(personalizationStates);
	            })
	                .catch(function (err) {
	                deferred.reject(err);
	            });
	            return deferred;
	        }
	        function loadPersonalizationData(users) {
	            return $q.all(users.map(function _loadPersonalizationData(user) {
	                return PersonalizationService.loadPersonalizationData(user._id, currentCompanyId, ['searches', 'dashboards', 'tags', 'rssFeeds', 'labels']);
	            }));
	        }
	        function getLabelsPersonalizationToggle() {
	            // The default state for this treatment is all that matters, and user information is hard to get at.
	            // Just send in dummy information to identity the user.
	            return $http.post(FEATURE_TOGGLE_URL + '/treatment/anyone', {
	                attributes: {},
	                feature: 'LABELS_PERSONALIZATION_UI'
	            }).then(function labelSuccess(result) {
	                return result.data.feature === 'on';
	            });
	        }
	        function openModal(users, companyId, event) {
	            currentUsers = users;
	            currentCompanyId = companyId;
	            var dialogDetails = {
	                autoWrap: false,
	                bindToController: true,
	                targetEvent: event,
	                locals: {
	                    users: users,
	                    personalizationStatesDeferred: getPersonalizationStatesDeferred(),
	                    labelsFeatureEnabled: false
	                },
	                template: '<md-dialog class="mw-mini-modal" aria-label="" layout="column">' +
	                    '<visibility-personalization-dialog class="mw-mini-modal-wrapper mw-user-collection__action-visibility-personalization-dialog" layout="column" users="$ctrl.users" personalization-states-deferred="$ctrl.personalizationStatesDeferred" labels-feature-enabled="$ctrl.labelsFeatureEnabled"></visibility-personalization-dialog>' +
	                    '</md-dialog>',
	                controller: function () {
	                },
	                controllerAs: '$ctrl'
	            };
	            return loadPersonalizationData(users)
	                .then(function showVisibilityDialog() {
	                getLabelsPersonalizationToggle()
	                    .then(function (labelsFeatureEnabled) {
	                    dialogDetails.locals.labelsFeatureEnabled = labelsFeatureEnabled;
	                    $mdDialog.show(dialogDetails).then(onVisibilityPersonalizationDialogOk);
	                }).catch(function (err) {
	                    // If getting personalization fails, just leave labels hidden and move on.
	                    $log.warn('Unable to get labels toggle due to an error - hiding labels feature', err);
	                    $mdDialog.show(dialogDetails).then(onVisibilityPersonalizationDialogOk);
	                });
	            })
	                .catch(function (error) {
	                $log.error('Failed retrieving data for the VisibilityPersonalizationDialog', error);
	                DialogService.flashError(translationService.getLocalizedString('mw-user-collection__action-visibility-personalization-dialog-flash-message--display-fail'), 5);
	            });
	        }
	        function onVisibilityPersonalizationDialogOk(dialogResult) {
	            var personalizations = {}, users = dialogResult.users, userIds = users.map(function (user) { return user._id; }), personalizationStates = dialogResult.personalizationStates;
	            if (Object.keys(personalizationStates).length > 0) {
	                for (var type in personalizationStates) {
	                    personalizations[type] = {};
	                    for (var i in personalizationStates[type]) {
	                        if (personalizationStates[type][i].visibility == 'hidden') {
	                            personalizations[type][i] = { hidden: true };
	                        }
	                        else if (personalizationStates[type][i].visibility == 'visible') {
	                            personalizations[type][i] = { hidden: false };
	                        }
	                        else {
	                            $log.error('Encountered unexpected visibility state "' + personalizationStates[type][i].visibility + '"');
	                        }
	                    }
	                }
	                return PersonalizationService.bulkUpdateCollectionVisibility(userIds, currentCompanyId, personalizations)
	                    .then(function () {
	                    DialogService.flashSuccess(translationService.getLocalizedString('mw-user-collection__action-visibility-personalization-dialog-flash-message--success'));
	                })
	                    .catch(function (error) {
	                    $log.error('Failed updating personalizations', error);
	                    DialogService.flashError(translationService.getLocalizedString('mw-user-collection__action-visibility-personalization-dialog-flash-message--fail'));
	                });
	            }
	        }
	    }]);

	angular.module('MW.Framework.VisibilityPersonalizationConfig', [])
	    .service('PersonalizationConfig', [
	    'ENV',
	    function PersonalizationConfig(ENV) {
	        var labelsUri = 'https://v1.labels.meltwater.io';
	        if (['staging', 'development', 'dev', 'local', ''].indexOf(ENV) !== -1) {
	            labelsUri = 'https://v1.staging.labels.meltwater.io';
	        }
	        return {
	            labelsUri: labelsUri
	        };
	    }
	]);

	var build = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });





	exports.default = angular$1.module('mwPersonalizationComponents', [
	    'MW.Framework.PersonalizationService',
	    'MW.Framework.VisibilityPersonalizationDialog',
	    'MW.Framework.VisibilityPersonalizationDialogService',
	    'MW.Framework.VisibilityPersonalizationConfig'
	]);
	});

	var index = unwrapExports(build);

	exports.default = index;

	Object.defineProperty(exports, '__esModule', { value: true });

}));



/*****************
 ** WEBPACK FOOTER
 ** ./~/@meltwater/gaf-ng-components-personalization/gaf-ng-components-personalization.umd.js
 ** module id = 151
 ** module chunks = 0 1
 **/